class AppController {
  /* @ngInject */
  constructor($rootScope, $state, pathSuperAdmin, NewTokenService, StorageService) {
    const that = this;
    that.logout = false;
    that.showSideBar = $state.current.name !== 'listaMerchantSuperAdmin';

    const deregLoginListener = $rootScope.$on('USER_LOGGED_IN', () => {
      that.logout = false;
    });

    const deregLogoutListener = $rootScope.$on('USER_LOGGED_OUT', () => {
      that.logout = true;
    });

    const deregStateChangedListener = $rootScope.$on('$stateChangeSuccess', () => {
      if (StorageService.getLocalStorage('superAdmin') === 'true' && NewTokenService.getUserContext() === undefined) {
        $state.go('listaMerchantSuperAdmin');
        return;
      }
      that.showSideBar = $state.current.name !== 'listaMerchantSuperAdmin';
    });

    const deRegSuperAdminListener = $rootScope.$on('SUPER_ADMIN_LOGGED_IN', () => {
      that.logout = false;
    });

    that.$onDestroy = () => {
      deregLoginListener();
      deregLogoutListener();
      // deregUnauthorizedListener();
      deregStateChangedListener();
      deRegSuperAdminListener();
    };
  }
}

export default AppController;



/** WEBPACK FOOTER **
 ** ./client/app/app.controller.js
 **/